<template>
<div>
    <Breadcrumbs main="Projects" title="Tasks" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 project-list">
                <div class="card">
                    <div class="card-body">

                        <div v-if="!loading && !error">

                            <!-- ===== TOP TABS: TODAY / ALL (together, side by side) ===== -->
                            <div class="tab-row">
                                <button
                                    type="button"
                                    class="tab-btn today"
                                    :class="{ active: activeTab === 'today' }"
                                    @click="activeTab = 'today'"
                                >
                                    TODAY
                                    <span class="count-badge">{{ validDeadlineTask.length }}</span>
                                </button>

                                <button
                                    type="button"
                                    class="tab-btn all"
                                    :class="{ active: activeTab === 'all' }"
                                    @click="activeTab = 'all'"
                                >
                                    ALL
                                    <span class="count-badge">{{ validAllTask.length }}</span>
                                </button>
                            </div>

                            <!-- ===== PROJECT LIST FOR THE SELECTED TAB ===== -->
                            <div class="project-list-area">
                                <div v-if="activeList.length > 0">
                                    <div
                                        v-for="project in activeList"
                                        :key="activeTab + '-' + project.project_id.id"
                                        class="project-accordion-item"
                                    >
                                        <div
                                            class="project-accordion-header"
                                            @click="toggleProject(project.project_id.id)"
                                        >
                                            <div class="project-title" :title="project.project_id.title">
                                                <span class="chevron">
                                                    <i
                                                        class="fa"
                                                        :class="openProject[project.project_id.id] ? 'fa-angle-up' : 'fa-angle-down'"
                                                    ></i>
                                                </span>
                                                {{ project.project_id.title }}
                                            </div>
                                            <span class="task-count">
                                                {{ project.tasks.length }} task{{ project.tasks.length === 1 ? '' : 's' }}
                                            </span>
                                        </div>

                                        <div
                                            v-show="openProject[project.project_id.id]"
                                            class="project-accordion-body"
                                        >
                                            <div
                                                v-for="task in project.tasks"
                                                :key="task.task_id.id"
                                                class="task-card"
                                            >
                                                <!-- TASK header line -->
                                                <div class="task-header">
                                                    <input
                                                        type="checkbox"
                                                        class="row-checkbox"
                                                        v-model="task.task_id.complete"
                                                        @click="Task(task.task_id.id)"
                                                    >
                                                    <div class="task-title-col">
                                                        <router-link
                                                            :to="{ name: 'ProjectDetail', params: { id: task.task_id.project }, query: { task: task.task_id.id } }"
                                                            class="link-style task-title"
                                                            :title="task.task_id.title"
                                                        >
                                                            {{ task.task_id.title }}
                                                        </router-link>
                                                    </div>

                                                    <div class="task-info-col">
                                                        <div class="meta-row">
                                                            <span class="pill" :class="statusClass(task.task_id.status)">
                                                                {{ task.task_id.status }}
                                                            </span>
                                                            <span class="pill priority">
                                                                Priority: {{ task.task_id.priority }}
                                                            </span>
                                                            <span class="pill dates">
                                                                <i class="fa fa-calendar"></i>
                                                                {{ task.task_id.start_date }} → {{ task.task_id.end_date }}
                                                            </span>
                                                            <span v-if="task.task_id.progress != null" class="pill progress">
                                                                Progress: {{ task.task_id.progress }}%
                                                            </span>
                                                            <span v-if="task.task_id.complete && task.task_id.completed_date" class="pill completed">
                                                                <i class="fa fa-check"></i>
                                                                Completed: {{ task.task_id.completed_date }}
                                                            </span>
                                                        </div>

                                                        <!-- TASK description -->
                                                        <p v-if="task.task_id.description" class="task-desc">
                                                            {{ stripHtml(task.task_id.description) }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <!-- SUBTASKS: compact list view (handles large counts without breaking layout) -->
                                                <div v-if="task.subtasks.length > 0" class="subtask-list">
                                                    <div class="subtask-list-label">
                                                        <i class="fa fa-level-up fa-rotate-90"></i>
                                                        SUBTASKS ({{ task.subtasks.length }})
                                                    </div>
                                                    <div
                                                        v-for="subtask in task.subtasks"
                                                        :key="subtask.id"
                                                        class="subtask-row"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="row-checkbox"
                                                            v-model="subtask.complete"
                                                            @click="subTask(subtask.id)"
                                                        >
                                                        <router-link
                                                            :to="{ name: 'ProjectDetail', params: { id: task.task_id.project }, query: { task: task.task_id.id } }"
                                                            class="link-style subtask-title"
                                                            :title="subtask.title"
                                                        >
                                                            {{ subtask.title }}
                                                        </router-link>

                                                        <span class="pill sm" :class="statusClass(subtask.status)">
                                                            {{ subtask.status }}
                                                        </span>
                                                        <span class="pill sm dates">
                                                            {{ subtask.start_date }} → {{ subtask.end_date }}
                                                        </span>
                                                        <span v-if="subtask.complete && subtask.completed_date" class="pill sm completed">
                                                            <i class="fa fa-check"></i> {{ subtask.completed_date }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else class="empty-box">
                                    <h6>
                                        {{ activeTab === 'today'
                                            ? 'No active tasks have a deadline today!'
                                            : 'No tasks found!' }}
                                    </h6>
                                </div>
                            </div>

                        </div>

                        <div v-else class="col-lg-12 my-2">
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { myHost } from "../../../_helpers/host";

export default {
    data() {
        return {
            host: myHost.host,
            activeTab: 'today',   // 'today' or 'all' - both tabs live together at the top
            openProject: {}       // key: projectId -> boolean (expanded state)
        }
    },

    computed: {
        ...mapState({
            allTask: state => state.project.myTask,
            loading: state => state.project.submitLoading,
            error: state => state.project.submitError,
            deadlineTask: state => state.project.myTaskDeadline,
        }),

        // Filter out any malformed entries (missing project_id / tasks / ids)
        // so a bad record from the API can't crash the render.
        validDeadlineTask() {
            return this.safeProjectList(this.deadlineTask);
        },

        validAllTask() {
            return this.safeProjectList(this.allTask);
        },

        activeList() {
            return this.activeTab === 'today' ? this.validDeadlineTask : this.validAllTask;
        }
    },

    mounted() {
        // === API calls happen here ===
        this.$store.dispatch("project/fetchMyTask")             // -> populates allTask
        this.$store.dispatch("project/fetchMyTaskDeadlinToday") // -> populates deadlineTask
    },

    methods: {
        // Keeps only entries that actually have a project_id and a tasks array,
        // and drops any task/subtask entries missing their own id fields.
        safeProjectList(list) {
            if (!Array.isArray(list)) return [];

            return list
                .filter(p => p && p.project_id && p.project_id.id != null)
                .map(p => ({
                    ...p,
                    tasks: Array.isArray(p.tasks)
                        ? p.tasks
                            .filter(t => t && t.task_id && t.task_id.id != null)
                            .map(t => ({
                                ...t,
                                subtasks: Array.isArray(t.subtasks)
                                    ? t.subtasks.filter(s => s && s.id != null)
                                    : []
                            }))
                        : []
                }));
        },

        toggleProject(projectId) {
            this.$set(this.openProject, projectId, !this.openProject[projectId]);
        },

        statusClass(status) {
            const key = (status || '').toLowerCase();
            if (key === 'completed' || key === 'done') return 'status-done';
            if (key === 'working' || key === 'in_progress' || key === 'in-progress') return 'status-working';
            if (key === 'pending') return 'status-pending';
            return 'status-default';
        },

        stripHtml(html) {
            if (!html) return '';
            const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
            return text.length > 220 ? text.slice(0, 220) + '…' : text;
        },

        Task(id) {
            this.$store.dispatch("project/togglTaskComplete", {
                id: id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        subTask(id) {
            this.$store.dispatch("project/toggleSubTaskComplete", {
                id: id,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
/* ---- Top tabs: TODAY + ALL together ---- */
.tab-row {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
}

.tab-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #555;
    background: #eef0f5;
    cursor: pointer;
    opacity: 0.6;
    transition: all 0.15s ease;
}

.tab-btn.active {
    opacity: 1;
    color: #fff;
}

.tab-btn.today.active {
    background: #dc3545;
}

.tab-btn.all.active {
    background: #2f4cdd;
}

.count-badge {
    background: rgba(0, 0, 0, 0.15);
    padding: 2px 9px;
    border-radius: 10px;
    font-size: 12px;
}

.tab-btn.active .count-badge {
    background: rgba(255, 255, 255, 0.25);
}

.empty-box {
    padding: 16px;
    text-align: center;
    color: #777;
}

/* ---- Project accordion ---- */
.project-accordion-item {
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    margin-bottom: 10px;
    background: #fff;
    overflow: hidden;
}

.project-accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    cursor: pointer;
    background: #f4f5f9;
}

.project-accordion-header:hover {
    background: #ebedf5;
}

.project-title {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    font-weight: 600;
}

.chevron {
    font-size: 13px;
    color: #666;
    flex-shrink: 0;
}

.project-title-text {
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 320px;
    display: inline-block;
}

.task-count {
    font-size: 12px;
    color: #888;
    flex-shrink: 0;
    margin-left: 10px;
}

.project-accordion-body {
    padding: 14px 16px;
    border-top: 1px solid #eee;
}

/* ---- Task row: grid layout so every task lines up in the same columns ---- */
.task-card {
    padding: 12px;
    border: 1px solid #dbe0ff;
    border-left: 4px solid #2f4cdd;
    border-radius: 6px;
    margin-bottom: 12px;
    background: #fcfcff;
}

.task-card:last-child {
    margin-bottom: 0;
}

.task-header {
    display: grid;
    grid-template-columns: 24px 220px 1fr;
    column-gap: 14px;
    align-items: start;
}

.row-checkbox {
    margin-top: 3px;
}

.task-title-col {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.type-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    padding: 2px 7px;
    border-radius: 4px;
    text-transform: uppercase;
    width: fit-content;
}

.task-tag {
    background: #2f4cdd;
    color: #fff;
}

.subtask-tag {
    background: #e9a63b;
    color: #fff;
}

.task-title {
    font-size: 15px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

.task-info-col {
    min-width: 0;
}

.task-title-col,
.task-info-col {
    padding-top: 1px;
}

.meta-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 6px;
}

.pill {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    background: #eee;
    color: #444;
    white-space: nowrap;
}

.pill.priority {
    background: #e6ecff;
    color: #2f4cdd;
}

.pill.dates {
    background: #f1f1f1;
    color: #555;
}

.pill.progress {
    background: #fff3cd;
    color: #8a6d1d;
}

.pill.completed {
    background: #d9f2e3;
    color: #1e7e42;
}

.status-pending {
    background: #ffe4ba;
    color: #915d00;
}

.status-working {
    background: #cfe2ff;
    color: #0850b8;
}

.status-done {
    background: #d9f2e3;
    color: #1e7e42;
}

.status-default {
    background: #e6e6e6;
    color: #555;
}

.task-desc {
    font-size: 13px;
    color: #666;
    margin: 4px 0 0 0;
    line-height: 1.4;
}

/* ---- Subtask list (compact rows, scales to many subtasks without breaking layout) ---- */
.subtask-list {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e0d4bb;
}

.subtask-list-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #b07d1f;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.subtask-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    margin-left: 12px;
    border-left: 3px solid #e9a63b;
    background: #fffaf1;
    border-radius: 4px;
    margin-bottom: 5px;
}

.subtask-row:last-child {
    margin-bottom: 0;
}

.subtask-title {
    font-size: 13.5px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
    flex-shrink: 1;
}

.pill.sm {
    font-size: 10.5px;
    padding: 1px 7px;
    flex-shrink: 0;
}

@media only screen and (max-width: 800px) {
    .tab-row {
        flex-direction: column;
    }

    .project-title-text {
        max-width: 160px;
    }

    .task-header {
        grid-template-columns: 24px 1fr;
        row-gap: 8px;
    }

    .task-title-col {
        grid-column: 2;
    }

    .task-info-col {
        grid-column: 1 / -1;
    }

    .subtask-row {
        flex-wrap: wrap;
    }

    .subtask-title {
        max-width: 160px;
    }
}
</style>